import { SVGFC } from '@repo/toolkit/types'

const UserSixIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15707_23408)">
        <path
          d="M11.4749 10.8757C12.5553 10.2574 13.2935 9.10595 13.2935 7.77447C13.2935 5.79662 11.6844 4.1875 9.70652 4.1875C7.72867 4.1875 6.11955 5.79662 6.11955 7.77447C6.11955 9.10595 6.85775 10.2574 7.93814 10.8757C5.23575 11.5853 3.25 13.8702 3.25 16.5783V17.4592C3.25 17.6572 3.41071 17.8179 3.60871 17.8179C3.80671 17.8179 3.96741 17.6572 3.96741 17.4592V16.5783C3.96738 13.7023 6.54212 11.3614 9.70652 11.3614C12.8709 11.3614 15.4457 13.7023 15.4457 16.5783V17.4592C15.4457 17.6572 15.6064 17.8179 15.8044 17.8179C16.0024 17.8179 16.1631 17.6572 16.1631 17.4592V16.5783C16.163 13.8702 14.1773 11.5846 11.4749 10.8757ZM6.83697 7.77447C6.83697 6.19191 8.12396 4.90491 9.70652 4.90491C11.2891 4.90491 12.5761 6.19191 12.5761 7.77447C12.5761 9.35702 11.2891 10.644 9.70652 10.644C8.12396 10.644 6.83697 9.35705 6.83697 7.77447Z"
          fill={color}
        />
        <path
          d="M16.3056 10.8839C17.0833 10.3695 17.5984 9.48996 17.5984 8.49065C17.5984 6.90809 16.3114 5.62109 14.7288 5.62109C14.5308 5.62109 14.3701 5.7818 14.3701 5.9798C14.3701 6.1778 14.5308 6.33851 14.7288 6.33851C15.9154 6.33851 16.881 7.30413 16.881 8.49068C16.881 9.67723 15.9154 10.6429 14.7288 10.6429C14.5308 10.6429 14.3701 10.8036 14.3701 11.0016C14.3701 11.1996 14.5308 11.3602 14.7288 11.3602C17.1026 11.3602 19.0331 13.1443 19.0331 15.3381V16.0232C19.0331 16.2212 19.1938 16.3819 19.3918 16.3819C19.5898 16.3819 19.7505 16.2212 19.7505 16.0232V15.3381C19.7505 13.2649 18.3043 11.5037 16.3056 10.8839Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15707_23408">
          <rect width="16.5" height="16.5" fill="white" transform="translate(3.25 2.75)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default UserSixIcon
